export default {
  getDependenciesMsg (data) {
    let dependencies = []
    dependencies.push('Las siguientes Entidades comerciales poseen dependencia con este Lugar.')
    dependencies.push(' ')
    dependencies.push(...data.map(item => {
      let { name, cuit } = item
      return `Nombre: ${name}, CUIT: ${cuit}. `
    }))
    dependencies.push(' ')
    dependencies.push(' ')
    dependencies.push('Por favor, elimine las dependencias y vuelva a intentarlo.')
    return dependencies
  },
  filterLocations (locations, filters) {
    let filteringEntity = locations
    const { name, city, address, postalCode, typeId } = filters
    if (name) {
      filteringEntity = filteringEntity.filter((i) => {
        return !(i.name.search(new RegExp(name, 'i')) < 0)
      })
    }
    if (city) {
      filteringEntity = filteringEntity.filter((i) => {
        return !(i.city.search(new RegExp(city, 'i')) < 0)
      })
    }
    if (address) {
      filteringEntity = filteringEntity.filter((i) => {
        return !(i.address.search(new RegExp(address, 'i')) < 0)
      })
    }
    if (postalCode) {
      filteringEntity = filteringEntity.filter((i) => {
        return !(i.postalCode.search(new RegExp(postalCode, 'i')) < 0)
      })
    }
    if (typeId) {
      filteringEntity = filteringEntity.filter(i => (i.types || []).some(type => type.id === typeId))
    }
    return filteringEntity
  }
}
